import { graphql, useStaticQuery } from 'gatsby'

import { HeaderNav } from '@application/Types/HeaderTypes'

export const useGetHeader = (language = 'en'): HeaderNav[] => {
    const data = useStaticQuery(
        graphql`
            fragment LinkFragment on STRAPI__COMPONENT_TWO_COLUMNS_SUBMENU_LINKS {
                label
                link
                description {
                    data {
                        description
                    }
                }
            }
            fragment dynamicColumnFragment on STRAPI__COMPONENT_MENU_DYNAMIC_COLUMNS {
                id
                strapi_component
                menuLinkSections: menu_link_sections {
                    buttonLabel
                    buttonStyle
                    buttonUrl
                    title
                    link {
                        name
                        url
                        description
                        tag
                        icon {
                            alternativeText
                            localFile {
                                childImageSharp {
                                    gatsbyImageData(width: 30)
                                }
                                publicURL
                                extension
                            }
                        }
                    }
                }
                showFooter
                footerDescription
                footerLinkLabel
                footerLinkUrl
                footerImage {
                    alternativeText
                    localFile {
                        childImageSharp {
                            gatsbyImageData
                        }
                        publicURL
                        extension
                    }
                }
                lastColumnImage {
                    alternativeText
                    localFile {
                        childImageSharp {
                            gatsbyImageData
                        }
                        publicURL
                        extension
                    }
                }
                imagePosition
                imageColumnTitle
                ImageColumnDescription
                imageColumnLinkLabel
                imageColumnLinkUrl
            }
            query Header {
                allStrapiHeaderNavigation(filter: { enabled: { eq: true } }) {
                    nodes {
                        language
                        link
                        label
                        position
                        order
                        linkStyle
                        submenu {
                            ... on STRAPI__COMPONENT_TWO_COLUMNS_SUBMENU_TWO_COLUMNS {
                                id
                                strapi_component
                                leftLinks {
                                    ...LinkFragment
                                }
                                rightLinks {
                                    ...LinkFragment
                                }
                            }
                            ... on STRAPI__COMPONENT_THREE_COLUMNS_SUBMENU_THREE_COLUMNS_SUBMENU {
                                id
                                strapi_component
                                leftColumnHeader
                                centerColumnHeader
                                rightColumnHeader
                                leftColumnLinks {
                                    ...LinkFragment
                                }
                                rightColumnLinks {
                                    ...LinkFragment
                                }
                                centerColumnLinks {
                                    ...LinkFragment
                                }
                            }
                            ...dynamicColumnFragment
                        }
                    }
                }
            }
        `
    )

    return data?.allStrapiHeaderNavigation.nodes.filter((node: HeaderNav) => node.language === language)
}
